import $ from 'jquery';
import toastr from 'toastr';

export function mountAllCriteria(input) {
  var criteria = [];
  var blankField = false;

  $(input + ' input[name^=criteria]').each(function(){
    if ($(this).val() == "") {
      blankField = true;
    }
    criteria.push($(this).val());
  });

  var criteriaStatus = [];
  $(input + ' input[name^=criteriumStatus]').each(function(){
    criteriaStatus.push($(this).val());
  });

  var criteriaId = [];
  $(input + ' input[name^=criteriumId]').each(function() {
    criteriaId.push($(this).val());
  });

  allCriteria = [];
  criteria.forEach(function(object, index) {
    var criterium = {
      criterium: object,
      status: criteriaStatus[index],
      id: criteriaId[index],
    }
    allCriteria.push(criterium);
  });

  if (criteria == "") {
    return "";
  }

  if (blankField) {
    return "blank";
  }

  return allCriteria;
}

export function editAndDeleteButtons() {
  var $deleteCriteria =  $('.delete-criteria-js');
  var $editCriteria = $('.edit-criteria-js');

  $deleteCriteria.unbind().click(function() {
    var resourceId = $(this).data('value');
    var criteriaKind = $(this).data('kind');

    var $selectedCriterium = $(this);
    var secretaryId = $('.select-secretaries-config-js option:selected').val();

    if (resourceId === undefined) {
      $(this).closest('.criterium-input-js').detach();
    } else {
      $.ajax({
        method: 'GET',
        url: './configs/verify_school_criterium',
        data: {
          kind: criteriaKind,
          resource_id: resourceId
        },
        success: function(data) {
          alertConfirm(secretaryId, criteriaKind, resourceId, $selectedCriterium);
        },
        error: function(data) {
          toastr.error(data.responseJSON.message);
        }
      });
    }
  });

  $editCriteria.unbind().click(function() {
    var resourceId = $(this).data('value');
    var criteriaKind = $(this).data('kind');
    var $selectedCriterium = $(this);

    if (resourceId === undefined) {
      $(this).closest('.criterium-field-js').prop('disabled', false);
    } else {
      $.ajax({
        method: 'GET',
        url: './configs/verify_school_criterium',
        data: {
          kind: criteriaKind,
          resource_id: resourceId
        },
        success: function(data) {
          $selectedCriterium.parent().parent().find('.criterium-field-js').prop('disabled', false);
        },
        error: function(data) {
          toastr.error(data.responseJSON.message);
        }
      });
    }
  });
}

function deleteCriterium(secretaryId, criteriaKind, resourceId, $selectedCriterium) {

  $.ajax({
    method: 'DELETE',
    url: './configs/delete_criterium',
    data: {
      kind: criteriaKind,
      resource_id: resourceId,
      secretary_id: secretaryId
    },
    success: function(data) {
      toastr.success(I18n.t('views.configs.criteria.deleted'));
      refreshValues();
    },
    error: function(data) {
      if (data.responseJSON) {
        toastr.error(data.responseJSON.message);
      } else if (data.message){
        toastr.error(data.message);
      }
    }
  });
}

function alertConfirm(secretaryId, criteriaKind, criteriaId, $selectedCriterium) {
  $("#deleteConfirmModal").modal('show');

  $("#modalBtnYes").unbind().click(function() {
    deleteCriterium(secretaryId, criteriaKind, criteriaId, $selectedCriterium);
    $("#deleteConfirmModal").modal('hide');
  });

  $("#modalBtnNo").unbind().click(function() {
    $("#deleteConfirmModal").modal('hide');
  });
}

export function mountDiaryClassCriteria() {
  var categories = [];
  $('.class-diary-all-criteria input[name^=categoryId]').each(function() {
    categories.push($(this).val());
  });

  var criteria = [];
  var blankField = false;
  $('.class-diary-all-criteria input[name^=criteria]').each(function(){
    if ($(this).val() == "" && !($(this).is(':disabled'))) {
      blankField = true;
    }
    criteria.push($(this).val());
  });

  var criteriaStatus = [];
  $('.class-diary-all-criteria input[name^=criteriumStatus]').each(function(){
    criteriaStatus.push($(this).val());
  });

  var criteriaId = [];
  $('.class-diary-all-criteria input[name^=criteriumId]').each(function() {
    criteriaId.push($(this).val());
  });

  diaryClassCriteria = [];
  criteria.forEach(function(object, index) {
    var criterium = {
      category: categories[index],
      criterium: object,
      status: criteriaStatus[index],
      id: criteriaId[index]
    }
    diaryClassCriteria.push(criterium);
  });

  if (criteria == "") {
    return "";
  }

  if (blankField) {
    return "blank";
  }

  return diaryClassCriteria;
}

export function mountCategories() {
  var categoriesId = [];
  $('.category-criteria-js input[name^=categoriesId]').each(function() {
    categoriesId.push($(this).val());
  });

  var categories = [];
  var blankField = false;
  $('.category-criteria-js input[name^=categoriesName]').each(function(){
    if ($(this).val() == "" && !($(this).is(':disabled'))) {
      blankField = true;
    }
    categories.push($(this).val());
  });

  var categoriesStatus = [];
  $('.category-criteria-js input[name^=categoriesStatus]').each(function(){
    categoriesStatus.push($(this).val());
  });

  var diaryClassCategories = [];
  categories.forEach(function(object, index) {
    var criterium = {
      name: object,
      status: categoriesStatus[index],
      id: categoriesId[index]
    }
    diaryClassCategories.push(criterium);
  });

  if (categories == "") {
    return "";
  }

  if (blankField) {
    return "blank";
  }

  return diaryClassCategories;
}

export function mountAlerts() {
  var alertsId = [];
  $('.alerts-configurations input[name^=alertId]').each(function() {
    alertsId.push($(this).val());
  });

  alertsId = alertsId.filter(function (x, i, a) {
    return a.indexOf(x) === i;
  });

  var percentageSelected = [];
  $(".alerts-configurations input[type='radio']:checked").each(function() {
    percentageSelected.push($(this).val());
  });

  var alerts = [];
  alertsId.forEach(function(object, index) {
    var alert = {
      percentage: percentageSelected[index],
      alert: object
    }
    alerts.push(alert);
  });

  return alerts;
}

export function mountWhatsappIntegrationForm() {
  var hasWassenger = $('#hasWassenger')[0].checked;
  var wassengerToken = $('#wassengerToken').val();
  var phoneNumber = $('#phoneNumber').val();
  var wassengerDeviceId = $('#wassengerDeviceId').val();
  return {
    has_wassenger: hasWassenger,
    token: wassengerToken,
    phone_number: phoneNumber,
    device_id: wassengerDeviceId
  }
}
